/* eslint-disable */
import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { MaterialReactTable } from "material-react-table";

import AutomationHeader from "components/AutomationComponents/AutomationConfig/AutomationHeader/AutomationHeader";

import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import {automationHeaderLinks} from "helper/AutomationHelper/AutomationMenuLinks";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData } from "utils/Gateway";

import typeOptions from "data/Automation/Type.json";
import actionOptions from "data/Automation/Actions.json";

const AutomationListBody = () => {

    const token = localStorage.getItem("token");
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    const moduleAccess = localStorage.getItem("moduleaccess");
    const { t, i18n } = useTranslation(); //for translation

    const commonHeaderObject = automationHeaderLinks(t);

    const [isLoading, setIsLoading] = useState(false);
    const [automationList, setAutomationList] = useState([]);

    //optionally, you can manage the row selection state yourself
    const [rowSelection, setRowSelection] = useState({});
    const [selectedItemIds, setSelectedItemIds] = useState([]);
    const [selectedAutomationId, setSelectedAutomationId] = useState(null);

    const [reloadData, setReloadData] = useState(false);

    // Pagination -------------------------------------------
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10, //customize the default page size
    });

    const [lastPagination, setLastPagination] = useState({
        pageIndex: 0,
        pageSize: 10, //customize the default page size
    });

    //alert requirements
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [messageType, setMessageType] = useState("");

    

  //get all automation
  const getAllAutomation = async () => {

    setSelectedItemIds([]);
    setRowSelection({});

    try {
      setIsLoading(true);

      let requestUrl =
        url.API_BASE_URL + url.API_AUTOMATION_CONFIG + `?token=${token}`;

        console.log(`getAllAutomation requestUrl--->`, requestUrl);

        const response = await getData(requestUrl);

        console.log("response in automation list------->", response);
        setIsLoading(false);

        if (response.status) {
            setMessageType("success");
            setAutomationList(response.data);
        } else {
            setMessageType("error");
        }

        setAlertMessage(response.message);

    } catch (error) {
        console.error("Error fetching automation list------->", error);
        setAlertMessage(error.message);
        setMessageType("error");
    }

        setShowAlert(true);
  };

  //* Function for reset filter
  const resetFilterData = () => {

    setReloadData(true);
    // reset pagination to default
    setLastPagination({
      pageIndex: 0,
      pageSize: 10,
    });
    setPagination({
      pageIndex: 0,
      pageSize: 10,
    });
  };



  useEffect(() => {
    getAllAutomation();
  }, []);

  //  reloadData effect
  useEffect(() => {
    if (reloadData) {
      getAllAutomation();
      setReloadData(false);
    }
  }, [reloadData]);


   //** Material React Table Column and States
  const columns = useMemo(
    () => [
      {
        accessorKey: '#',
        header: t('Actions'),
        Cell: ({ row }) => (
          <Link
            className="action_btn_mui"
            to={`/admin/automation/save/${row.original._id}`}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </Link>
        ),
        enableColumnActions: false, // Hides the column action icon
        enableColumnDragging: false, // Hides the move icon
        enableSorting: false,
      },
      {
        accessorKey: 'name',
        header: t('Automation Name'),
        Cell: ({ row }) => (
          <p>
            <span className="d-block">{row.original.name}</span>
            <span style={{ minWidth: 60, color: "#888" }}>{row.original.code} </span>
          </p>
        ),
      },
      {
        accessorKey: 'isactive',
        header: t('Is Active'),
        Cell: ({ row }) => {
          const isActive = row.original.isactive;
          return (
            <p>
              <span
                className="d-block"
                style={{
                  color: isActive === false ? 'red' : undefined,
                  fontWeight: isActive === false ? 'bold' : undefined,
                }}
              >
                {isActive === false ? t('No') : t('Yes')}
              </span>
            </p>
          );
        },
      },
      {
        accessorKey: 'trigger',
        header: t('Trigger Module'),
        Cell: ({ row }) => (
          <p>
            <span className="d-block">{row.original.trigger.module?.name??''}</span>
          </p>
        ),
      },
      {
        accessorKey: 'trigger.type',
        header: t('Trigger Type'),
        Cell: ({ row }) => {
          const triggerType = row.original.trigger.type;
          const matchedType = typeOptions.find(option => option.value === triggerType);
          return (
            <p>
              <span className="d-block">{matchedType ? matchedType.label : triggerType}</span>
            </p>
          );
        },
      },
      {
        accessorKey: 'trigger.value',
        header: t('Trigger Value'),
        Cell: ({ row }) => {
          const trigger = row.original.trigger;
          let displayValue = '';
          
          // Determine display value based on trigger type
          if (trigger.type === 'mail_linktracker_label_added') {
            displayValue = trigger.linktracker?.label || trigger.value || t('No linktracker specified');
          } else {
            displayValue = trigger.tag?.label || trigger.value || t('No tag specified');
          }
          
          return (
            <p>
              <span className="d-block">{displayValue}</span>
            </p>
          );
        },
      },
      {
        accessorKey: 'steps',
        header: t('Steps'),
        size: 600, // Increase width for MaterialReactTable logic
        Cell: ({ row }) => (
          row.original.steps.length > 0 ? (
            <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
              {row.original.steps.map((step, index) => {
                const matchedAction = actionOptions.find(option => option.value === step.action);
                let value = '';
                let reference = '';
                switch (step.action) {
                  case 'wait':
                    value = step.duration;
                    reference = 'minutes';
                    break;
                  case 'send_email':
                  case 'send_notification':
                    value = step.messagetemplate?.name ?? t('No template specified');
                    reference = 'mail template'
                    break;
                  case 'add_tag':
                  case 'remove_tag':
                    value = step.tag?.title ?? t('No tag specified');
                    reference = 'label';
                    break;
                  case 'change_status':
                    value = step.parameters == "0" ? t('Disable') : t('Enable');
                    reference = '';
                    break;
                  case 'stop_automation':
                    {
                      const found = automationList.find(automation => automation._id === step.parameters);
                      value = found ? found.name : (isLoading ? "" : t('No automation specified'));
                      reference = 'automation';
                    }
                    break;
                  default:
                    value = step.parameters || t('No parameters specified');
                }
                return (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      fontSize: "0.95em",
                      padding: "2px 0",
                      borderBottom: index !== row.original.steps.length - 1 ? "1px solid #f0f0f0" : "none"
                    }}
                  >
                    <span style={{ minWidth: 60, color: "#888" }}>Step {step.order}</span>
                    <span style={{ minWidth: 120, fontWeight: 500 }}>{matchedAction ? matchedAction.label : step.action}</span>
                    <span>
                      {value}
                      {reference && (
                        <span style={{ fontSize: "0.8em", color: "#6c757d", marginLeft: 4 }}>{reference}</span>
                      )}
                    </span>
                  </div>
                );
              })}
            </div>
          ) : (
            <p className="text-muted">{t('No steps defined')}</p>
          )
        ),
      },

      {
        accessorKey: 'owner',
        header: t('Owner'),
        size: 300, // Increase width to accommodate owner information
        Cell: ({ row }) => (
          <div className="owner border-bottom-0 d-flex gap-1">
            <img
              className="rounded-circle"
              height={40}
              width={45}
              src={
                row.original.owner.image == ''
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.owner.image
              }
              alt="Babcock"
            />
            <p>
              <span className="d-block fw-bold">
                {row.original.owner.name}
              </span>
              <span className="d-block">{row.original.owner.email}</span>
            </p>
          </div>
        ),
      },
      {
        accessorKey: "createdAt",
        header: t("Date"),
        Cell: ({ row }) => (
          <div>
            <span>{new Date(row.original.createdAt).toLocaleDateString() || t("N/A")}</span>
            <div className="text-muted"> {new Date(row.original.createdAt).toLocaleTimeString() || t("N/A")}</div>
          </div>
        ),
      },
      
    
    ],
    [i18n.language]
  );

  //initialize the column order
  const columnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ]; //array of column ids (Initializing is optional as of v2.10.0)

  //const [columnOrder, setColumnOrder] = useState(initialColumnOrder);

  //refresh icon function
  const refreshRecords = () => {
    resetFilterData();
    //setVisibleColoumns(initialVisibilityState);
    //setColumnOrder(initialColumnOrder);
  };

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" 
  ) {
    return (
      <div id="content_wrapper">
        <section className="survey-wrapper bg-white pb-5">

         <TabsHeader
              commonHeaderObject={commonHeaderObject}
              activeOption={t("Automation Config")}
            />

          <div className="container-fluid px-lg-5">

            <AutomationHeader reloadList={refreshRecords} />

            {isLoading ? (
              <div className="placeholder-glow d-flex flex-column gap-4">
                <span className="placeholder placeholder-lg bg-secondary col-12"></span>
                <span className="placeholder placeholder-lg bg-secondary col-8"></span>
                <span className="placeholder placeholder-lg bg-secondary col-4"></span>
              </div>
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns} // map columns to be displayed with api data,
                  data={automationList} // data from api to be displayed
                  enableGrouping
                  enableRowSelection // enable showing checkbox
                  getRowId={row => row._id} // map which value to select with row checkbox
                  onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                  state={{ rowSelection, columnOrder }} //pass our managed row selection state to the table to use
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 200,
                    size: 50, //make columns wider by default
                  }}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>
        </section>

        {/* ========= popups and modals area ======== */}

        {/* {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )} */}
      </div>
    );
  } else {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="empty_access text-center">
            <div className="empty_pic mb-4">
              {" "}
              <img src={assetImages.emptyVector} alt="" />
            </div>
            <div className="empty_text">
              <p className="fs-lg text-gray fw-semibold mb-4">
                {t("Sorry....! You don't have privilege to see this content")}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }


}

export default AutomationListBody;